const memberRouter = {
  path: '/member',
  name: 'Member',
  redirect: '/member/order',
  component: () => import('@/layout/memberHeader'),
  children: [
    {
      path: 'order',
      name: 'Order',
      redirect: 'order/index',
      component: () => import(/* webpackChunkName: "member" */ '@/pages/member'),
      children: [
        {
          path: 'index',
          name: 'Index',
          meta: { title: '个人中心' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/home')
        },
        {
          path: 'account',
          name: 'Account',
          meta: { title: '外汇账户' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/account')
        },
        {
          path: 'order',
          name: 'OrderList',
          meta: { title: '订单列表' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/order')
        },
        {
          path: 'myworkorder',
          name: 'Myworkorder',
          meta: { title: '工单列表' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/myworkorder')
        },
        {
          path: 'orderDetail',
          name: 'OrderDetail',
          meta: { title: '订单详情' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/orderDetail')
        },
        {
          path: 'user',
          name: 'MyInfo',
          meta: { title: '个人信息' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/myInfo')
        },
        {
          path: 'edit',
          name: 'Person_edit',
          meta: { title: '修改个人信息' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/myInfo/edit')
        },
        {
          path: 'collect',
          name: 'Collect',
          meta: { title: '收藏列表' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/collect')
        },
        {
          path: 'address',
          name: 'Address',
          meta: { title: '地址列表' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/address')
        },
        {
          path: 'message',
          name: 'Message',
          meta: { title: '消息通知' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/message')
        },
        {
          path: 'fastPayment',
          name: 'fastPayment',
          meta: { title: '银行卡列表' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/fastPayment')
        },
        {
          path: 'purchase',
          name: 'Purchase',
          meta: { title: '采购需求列表' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/purchase')
        },
        {
          path: 'footprint',
          name: 'Footprint',
          meta: { title: '我的足迹' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/footprint')
        },
        {
          path: 'response',
          name: 'Response',
          meta: { title: '地址列表' },
          component: () =>
            import(/* webpackChunkName: "member" */ '@/pages/member/purchase/pages/response')
        },
        {
          path: 'quoteDetail',
          name: 'QuoteDetail',
          meta: { title: '地址列表' },
          component: () =>
            import(/* webpackChunkName: "member" */ '@/pages/member/purchase/pages/quoteDetail')
        },
        {
          path: 'financial',
          name: 'Financial',
          meta: { title: '金融服务' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/financial')
        },
        {
          path: 'acupon',
          name: 'acupon',
          meta: { title: '卡劵列表' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/acupon')
        },
        {
          path: 'photo',
          name: 'photo',
          meta: { title: '专属相册' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/photo')
        },
        {
          path: 'invoice',
          name: 'Invoice',
          meta: { title: '发票信息' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/invoice')
        },
        {
          path: 'dispute',
          name: 'Dispute',
          meta: { title: '纠纷补偿' },
          component: () => import(/* webpackChunkName: "member" */ '@/pages/member/dispute')
        },
        {
          path: 'assist',
          name: 'Assist',
          meta: { title: '发布加工需求' },
          component: () => import('@/pages/member/assist/index')
        }
      ]
    },
    {
      path: 'hotelOrderDetail',
      name: 'HotelOrderDetail',
      meta: { title: '酒店订单详情' },
      component: () => import(/* webpackChunkName: "member" */ '@/pages/member/hotelOrderDetail')
    },
    {
      path: '/member/:id(\\d+)/detail',
      name: 'OrderEdit',
      meta: { title: '订单详情' },
      component: () => import(/* webpackChunkName: "member" */ '@/pages/member/orderDetail')
    },
    {
      path: '/evaluate/:id(\\d+)',
      name: 'Evaluate',
      meta: { title: '评价' },
      component: () => import('@/pages/member/evaluate')
    }
  ]
}

export default memberRouter
